import { useAsyncExecutor2, useAsyncExecutorPool } from "async-executor-hook";
import { useEffect, useState } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { Authorization } from "../../common/AuthorizationCpt";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { NOTIFICATIONS_COUNT_NOTIFICATION } from "../../utils/permissionConstant";
import { ADMIN_ROUTES } from "../../utils/routeConstants";
import { AdminAppointmentConfigurationResource } from "../AdminAppointmentConfiguration/AdminAppointmentConfigurationResource";
import { AdminComplaintsResource } from "../AdminComplaints/AdminComplaintsResource";
import AdminDocumentValidationResource from "../AdminDocumentValidation/AdminDocumentValidationResource";
import { AdminPaymentRecaudoResource } from "../AdminPaymentRecaudo/AdminPaymentRecaudoResource";
import AdminPaymentValidationResource from "../AdminPaymentValidation/AdminPaymentValidationResource";
import { AdminReportResource } from "../AdminReports/AdminReportResource";
import AdminTurnConfirmationResource from "../AdminTurnConfirmation/turnConfirmation/AdminTurnConfirmationResource";
import { BillingAdmin } from "../BillingAdmin/BillingAdmin";
import CreateComplaint from "../CreateComplaint/CreateComplaint";
import DocumentManagementHeader from "../DocumentManagementHeader/DocumentManagementHeader";
import { SyncronizeData } from "../SyncronizeData/SyncronizeData";
import UsersManagementAdminResource from "../UsersManagementAdmin/UsersManagementAdminResource";
import VtcTicketResource from "../VctTicketsAdmin/VtcTicketResource";
import { Container } from "./AdminDocumentManagementScreenStyles";
import { NewNotifications } from "./NewNotifications";

interface IAdminDocumentManagementScreen {
  userProfileMe: {};
  userInfo: {
    profile: {
      name: string;
    };
  };
}
function AdminDocumentManagementScreen(props: IAdminDocumentManagementScreen) {
  const { userProfileMe, userInfo } = props;
  const asyncExecutorPool = useAsyncExecutorPool("");
  const asyncExecutorPoolRolProcesses = useAsyncExecutorPool("");
  const loadRolProfilesBackoffice = useAsyncExecutor2(
    () => {
      return networkBackendRequest(`/roles/`, HTTP_METHODS.GET, {})
        .then((response) => response.json())
        .then((resp) => resp.roles);
    },
    {
      cache: true,
      onSuccess: () => {},
    }
  );

  const loadRolProcessesBackoffice = useAsyncExecutor2(
    () => {
      return networkBackendRequest(`/processes/`, HTTP_METHODS.GET, {}).then(
        (response) => response.json()
      );
    },
    {
      cache: true,
      onSuccess: () => {},
    }
  );

  useEffect(() => {
    asyncExecutorPool.addExecutor(
      "loadRolProfilesUserBackoffice",
      loadRolProfilesBackoffice
    );
    asyncExecutorPoolRolProcesses.addExecutor(
      "loadRolProcessesUserBackoffice",
      loadRolProcessesBackoffice
    );
    if (userInfo.profile.name === "Administrador") {
      loadRolProfilesBackoffice.execute({});
      loadRolProcessesBackoffice.execute({});
    }
    // eslint-disable-next-line
  }, [userInfo]);

  const history = useHistory();
  const [pathname, setPathname] = useState(history.location.pathname);

  useEffect(() => {
    const unsub = history.listen((location) => {
      setPathname(location.pathname);
    });
    return () => {
      unsub();
    };
  }, [history]);

  return (
    <Container>
      {pathname !== ADMIN_ROUTES.REPORTS.path && (
        <Authorization actions={[NOTIFICATIONS_COUNT_NOTIFICATION]}>
          <div>
            <NewNotifications />
          </div>
        </Authorization>
      )}
      <Switch>
        <Route path={ADMIN_ROUTES.BILLING_USERS_ADMIN.path}>
          <BillingAdmin userInfo={userInfo} />
        </Route>
        <Route path={ADMIN_ROUTES.DOCUMENT_VALIDATION.path}>
          <AdminDocumentValidationResource />
        </Route>

        <Route path={ADMIN_ROUTES.PAYMENT_VALIDATION.path}>
          <DocumentManagementHeader
            title={ADMIN_ROUTES.PAYMENT_VALIDATION.title.toUpperCase()}
          />
          <AdminPaymentValidationResource />
        </Route>

        <Route path={ADMIN_ROUTES.PAYMENT_RECAUDO.path}>
          <DocumentManagementHeader
            title={ADMIN_ROUTES.PAYMENT_RECAUDO.title.toUpperCase()}
          />
          <AdminPaymentRecaudoResource />
        </Route>

        <Route path={ADMIN_ROUTES.APPOINTMENT_CONFIGURATION.path}>
          <DocumentManagementHeader
            title={ADMIN_ROUTES.APPOINTMENT_CONFIGURATION.title.toUpperCase()}
          />
          <AdminAppointmentConfigurationResource />
        </Route>

        <Route path={ADMIN_ROUTES.TURN_CONFIRMATION.path}>
          <DocumentManagementHeader
            title={ADMIN_ROUTES.TURN_CONFIRMATION.title.toUpperCase()}
          />
          <AdminTurnConfirmationResource />
        </Route>

        <Route path={ADMIN_ROUTES.COMPLAINTS.path}>
          <DocumentManagementHeader
            title={ADMIN_ROUTES.COMPLAINTS.title.toUpperCase()}
          />
          <AdminComplaintsResource />
        </Route>

        <Route path={ADMIN_ROUTES.CREATE_COMPLAINTS.path}>
          <CreateComplaint />
        </Route>
        <Route path={ADMIN_ROUTES.SYNC_DATA.path}>
          <DocumentManagementHeader
            title={ADMIN_ROUTES.SYNC_DATA.title.toUpperCase()}
          />
          <SyncronizeData />
        </Route>
        <Route path={ADMIN_ROUTES.ADMIN_USERS.path}>
          <UsersManagementAdminResource
            userProfileMe={userProfileMe}
            userInfo={userInfo}
          />
        </Route>
        <Route path={ADMIN_ROUTES.APPOINTMENT_TICKETS.path}>
          <VtcTicketResource />
        </Route>

        <Route path={ADMIN_ROUTES.REPORTS.path}>
          <AdminReportResource />
        </Route>
      </Switch>
    </Container>
  );
}
export default AdminDocumentManagementScreen;
